import { render, staticRenderFns } from "./MenuControl.vue?vue&type=template&id=73a074d0"
import script from "./MenuControl.vue?vue&type=script&lang=js"
export * from "./MenuControl.vue?vue&type=script&lang=js"
import style0 from "./MenuControl.vue?vue&type=style&index=0&id=73a074d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports